export const creditCardReissueExternal = {
    targetClientId: 'C02345N6',
};
